import { lazy } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { Routes } from '../routeTypes';

export const ENROLLMENT_MEMBER_LIST_PATH = '/enrollment/member-list';

const useNavigationHooks = () => {
  const navigate = useNavigate();

  return {
    toEnrollmentMemberList: (options?: NavigateOptions) => {
      navigate(ENROLLMENT_MEMBER_LIST_PATH, options);
    },
  };
};

const EnrollmentMemberListPage = lazy(() =>
  import('react-components/enrollment/EnrollmentMemberListPage').then(
    module => ({
      default: module.EnrollmentMemberListPage,
    })
  )
);

const routes: Routes = [
  {
    path: ENROLLMENT_MEMBER_LIST_PATH,
    element: <EnrollmentMemberListPage />,
  },
];

export const enrollmentRouteConfig = {
  routes,
  useNavigationHooks,
};
